
import React from 'react'
import { Select, SelectProps } from 'antd';

export const StatusType = {
  toBeStart: 'toBeStart', // 未开始
  processing: 'processing', // 进行中
  end: 'end', // 已结束
  collarOver: 'collarOver', // 领光
  disable: 'disable', // 停用
  revoked: 'revoked', // 已撤销
} 

export const StatusTypeMap = {
  [StatusType.toBeStart]: '未开始',
  // Ai Start
  [StatusType.processing]: '进行中',
  [StatusType.end]: '已结束',
  [StatusType.collarOver]: '领光',
  [StatusType.disable]: '停用',
  [StatusType.revoked]: '已撤销',
  // Ai End
}

export interface FilterCouponStatusProps extends SelectProps {}


export const FilterCouponStatus = (props: FilterCouponStatusProps) => {
  const { placeholder = '优惠券状态', mode, ...reset } = props;
  const options = Object.entries(StatusTypeMap).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={[{ label: "全部", value: '' }, ...options]}
      placeholder={placeholder}
      {...reset}
    />
  )
}